import getTitle from 'helpers/getTitle'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {NullAsDefault} from 'views/Shared'
import getLinkToDetail from "../../../helpers/getLinkToDetail";
import {Link} from "react-router-dom";
import {ItemInformation} from "../../AppLocals/Organization/OrganizationEntity";
import {Avatar} from "antd";
import {FaMedal} from "react-icons/fa6";
import {formatSimplifyDate} from "../../../helpers/dateUtils";

const MedalDetail = ({item}) => {
    const t = useTranslate()
    return (
        <div className="border rounded m-2 p-2 space-y-2">
            student: {getTitle(item)}
        </div>
    )
}

const renderMedalAward = ({translate: t, isLg, renderContextMenu = NullAsDefault} = {}) => (item, index) => {
    const {medal, notes, visible, eff_date, ref} = item ?? {}
    const {owner} = item ?? {}

    return (
        <div key={index} className="flex flex-col lg:flex-row gap-3 rounded-lg custom-render-border relative">
            <Avatar
                src={medal?.avatar}
                style={{width: isLg ? 180 : "100%", minHeight: 120, maxHeight: 240}}
                icon={<FaMedal size={50} className="text-color-500"/>}
                className="flex flex-center background-200 rounded-lg"
            />
            <div className="py-3 flex flex-col flex-1 gap-1 rounded-b-lg">
                <div className="space-x-2 text-sm text-color-200 italic leading-snug">
                    {t(
                        "The certificate {medal} was awarded to {receiver_type} {receiver} for completing {reference}.",
                        {
                            medal: <span className="font-semibold text-green-600">{getTitle(medal)}</span>,
                            receiver_type: '',
                            receiver: t('you'),
                            reference: (
                                <Link
                                    to={getLinkToDetail(ref)}
                                    style={{ fontStyle: 'normal' }}
                                    className="font-bold text-color-000 no-underline">
                                    {getTitle(ref)}
                                </Link>
                            ),
                        }
                    )}
                </div>
                <div className="space-x-1 text-xs">
                    <span className="text-color-400 italic">
                        {t('organized by')}
                    </span>
                    <Link to={getLinkToDetail(medal?.owner)} className="font-semibold text-blue-600 no-underline">
                        {getTitle(medal?.owner)}
                    </Link>
                </div>
                <ItemInformation
                    showIcon={true} label="date of award"
                    value={formatSimplifyDate(eff_date, 'medium')}
                    className="text-xs italic"
                />
            </div>
        </div>
    )
}

export default renderMedalAward
